import { Module } from "vuex";
import { RootState } from "../types";
import { TalentsState } from "./types";
import { getters } from "./getter";
import { actions } from "./actions";
import { mutations } from "./mutations";

const state: TalentsState = {
  ids: [],
};

export const talents: Module<TalentsState, RootState> = {
  state,
  getters,
  actions,
  mutations,
};
